import { getCancelRequestUrl, getCompleteRequestUrl, getCreateRequestUrl, getDeclineRequestUrl, getOpenRequestsUrl, getReceivedRequestsUrl, getRequestUrl, getSentRequestsUrl } from "../endpoints";
import { useMutation, useQuery, useQueryClient } from "react-query";
import useAxios from "../../hooks/useAxios";


export const useGetRequest = (id) => {
    const client = useAxios();
    return useQuery(['getRequest', id], () => {
        return client.get(getRequestUrl(id));
    });
};

export const useGetSentRequests = () => {
    const client = useAxios();
    return useQuery('getSentRequests', () => {
        return client.get(getSentRequestsUrl());
    });
};

export const useGetReceivedRequests = () => {
    const client = useAxios();
    return useQuery('getReceivedRequests', () => {
        return client.get(getReceivedRequestsUrl());
    });
};

export const useGetOpenRequests = () => {
    const client = useAxios();
    return useQuery('getOpenRequests', () => {
        return client.get(getOpenRequestsUrl());
    });
}

export const useCreateRequest = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((body) => {
        return client.put(getCreateRequestUrl(), body);
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('getSentRequests');
        }
    });
};

export const useDeclineRequest = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((id) => {
        return client.patch(getDeclineRequestUrl(id));
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('getReceivedRequests');
        }
    });
};

export const useCompleteRequest = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation(({id, body}) => {
        return client.patch(getCompleteRequestUrl(id), body);
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('getReceivedRequests');
        }
    });
}

export const useCancelRequest = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((id) => {
        return client.delete(getCancelRequestUrl(id));
    }, {
        onMutate: async (id) => {
            await queryClient.cancelQueries('getSentRequests');
            await queryClient.cancelQueries(['getRequest', id]);

            const previousRequests = queryClient.getQueryData('getSentRequests');
            const previousRequest = queryClient.getQueryData(['getRequest', id]);
            
            queryClient.setQueryData('getSentRequests', (prev) => {
                return {
                    ...prev,
                    data: [...prev.data].map((request) => {
                        return (parseInt(request.id) === parseInt(id)) ? {...request, status: 'CANCELED'} : request
                    })
                };
            });

            queryClient.setQueryData(['getRequest', id], (prev) => {
                return {
                    ...prev,
                    data: {...prev.data, status: 'CANCELED'}
                };
            });

            return {previousRequests, previousRequest}; // to revert in case of error
        },
        onError: (_error, _artwork, context) => {
            queryClient.setQueryData('getSentRequests', context.previousRequests);
            queryClient.setQueryData(['getRequest', context.previousRequest.data.id], context.previousRequest);
        },
        onSettled: (response, error, id, contexts) => {
            queryClient.invalidateQueries('getSentRequests');
            queryClient.invalidateQueries(['getRequest', id]);
        }
    });
};